module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION BY THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])]), _c('a', {
    attrs: {
      "id": "intro"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Over the years since "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Egypt Game")]), _vm._v(" was first published, I’ve heard from a great many readers. Their letters have been wonderful, telling me how much they enjoyed the book and how they made up their own versions of the game, and almost always asking me the following question: “Where do you get your ideas?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That question is perhaps the one fiction writers hear more frequently than any other. But it’s the wrong question. A better one would be “How do you get your ideas?” Because getting story ideas is pretty much a matter of habit—the habit of taking interesting, but rather ordinary, bits and pieces of reality and building on them, weaving them together until a story emerges. Ideas can come from anywhere. Everyone has good sources of ideas. But the building and weaving part can be hard—fun and exciting but also difficult and demanding.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }, [_vm._v("I’ve often used "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Egypt Game")]), _vm._v(" to illustrate how any story can have “idea roots” that go back to different periods in one’s life. The longest root goes back to when I was in fifth grade and became fascinated by the culture of ancient Egypt. I read everything I could find on the subject, made up my own hieroglyphic alphabet, and played my own rather simple, and very private, Egypt Game, which included walking to school like an Egyptian—imagining ")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("myself as Queen Nefertiti, actually.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A somewhat shorter root goes back to when I was teaching in Berkeley, California, while my husband was in graduate school. My classes usually consisted of American kids of all races, as well as a few whose parents were graduate students from other countries. All six of the main characters in "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Egypt Game")]), _vm._v(" are based, loosely but with ethnic accuracy, on people who were in my class one year—even Marshall, whom I had to imagine backward in time to four years of age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the shortest root goes back to when my own daughter, a sixth-grader at the time, became intrigued by my stories about my “Egyptian period” and started her own version of the Egypt Game. Her game was much more complicated than mine and involved many of the activities I described in the story, including the mummification of our parakeet, who, like Elizabeth’s Prince Pete-ho-tep, died by feline assassination. A few years later, when my daughter was in her teens, she sometimes threatened to go through every one of my books looking for all the good ideas she had given me—and charge me for them!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But as I said before, all these idea roots came from rather ordinary sources that needed to be built on and woven together until they became the story of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Egypt Game.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Zilpha Keatley Snyder")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798567f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 63
// module chunks = 0